import { useEventBus } from '@/libs/hooks/use-event-bus';
import { PlaceDto } from '@/libs/api/place';
import { PLACE_LIKE_EVENT, PlaceLikeEvent } from '@/screen/place/hooks/usePlaceLike';
import React from 'react';

/**
 * Hook for listening to place like events and updating place data
 * @param setPlace Function to update place state
 */
export const usePlaceLikeEvent = (
  setPlace: React.Dispatch<React.SetStateAction<PlaceDto | null>>
) => {
  // Listen for place like events
  useEventBus<PlaceLikeEvent>(PLACE_LIKE_EVENT, (data) => {
    setPlace(prevPlace => {
      if (!prevPlace || prevPlace.id !== data.placeId) {
        return prevPlace;
      }

      // Calculate the new like count
      let newLikeCount = prevPlace.likeCount || 0;
      if (data.isLiked && !prevPlace.isLike) {
        // If liked and wasn't liked before, increment
        newLikeCount += 1;
      } else if (!data.isLiked && prevPlace.isLike) {
        // If unliked and was liked before, decrement
        newLikeCount = Math.max(0, newLikeCount - 1);
      }
      
      // Return updated place with new like status and count
      return {
        ...prevPlace,
        isLike: data.isLiked,
        likeCount: newLikeCount
      };
    });
  });
};